import React, { Component } from 'react';
import { Redirect, Route } from 'react-router';
import ReactTooltip from 'react-tooltip';
import Config from '../config';
import RequestHandler from '../helpers/request-handler';
import UserSession from '../helpers/user-session';
import Header from '../components/Header';
class Record extends Component {

    constructor(props) {
        super(props);
        this.state = { appstate: 'stopped', botAnsewer: false, toquestion: false , languge:'en-IN'}
        this.finalHtml = '';
        this.count = 0;
        this.recordId = 'temp';
        this.email_id = 'email';
        this.userDetail = {}; // first_name , 
        this.badWords = ["2 girls 1 cup","2g1c","4r5e","5h1t","5hit","a_s_s","a55","acrotomophilia","alabama hot pocket","alaskan pipeline","anal","anilingus","anus","apeshit","ar5e","arrse","arse","arsehole","ass","ass-fucker","ass-hat","ass-jabber","ass-pirate","assbag","assbandit","assbanger","assbite","assclown","asscock","asscracker","asses","assface","assfuck","assfucker","assfukka","assgoblin","asshat","asshead","asshole","assholes","asshopper","assjacker","asslick","asslicker","assmonkey","assmunch","assmuncher","assnigger","asspirate","assshit","assshole","asssucker","asswad","asswhole","asswipe","auto erotic","autoerotic","axwound","b!tch","b00bs","b17ch","b1tch","babeland","baby batter","baby juice","ball gag","ball gravy","ball kicking","ball licking","ball sack","ball sucking","ballbag","balls","ballsack","bampot","bangbros","bareback","barely legal","barenaked","bastard","bastardo","bastinado","bbw","bdsm","beaner","beaners","beastial","beastiality","beaver cleaver","beaver lips","bellend","bestial","bestiality","bi+ch","biatch","big black","big breasts","big knockers","big tits","bimbos","birdlock","bitch","bitchass","bitcher","bitchers","bitches","bitchin","bitching","bitchtits","bitchy","black cock","blonde action","blonde on blonde action","bloody","blow job","blow your load","blowjob","blowjobs","blue waffle","blumpkin","boiolas","bollock","bollocks","bollok","bollox","bondage","boner","boob","boobs","booobs","boooobs","booooobs","booooooobs","booty call","breasts","breeder","brotherfucker","brown showers","brunette action","buceta","bugger","bukkake","bulldyke","bullet vibe","bullshit","bum","bumblefuck","bung hole","bunghole","bunny fucker","busty","butt","butt plug","butt-pirate","buttcheeks","buttfucka","buttfucker","butthole","buttmuch","buttplug","c0ck","c0cksucker","camel toe","camgirl","camslut","camwhore","carpet muncher","carpetmuncher","cawk","chesticle","chinc","chink","choad","chocolate rosebuds","chode","cipa","circlejerk","cl1t","cleveland steamer","clit","clitface","clitfuck","clitoris","clits","clover clamps","clusterfuck","cnut","cock","cock-sucker","cockass","cockbite","cockburger","cockeye","cockface","cockfucker","cockhead","cockjockey","cockknoker","cocklump","cockmaster","cockmongler","cockmongruel","cockmonkey","cockmunch","cockmuncher","cocknose","cocknugget","cocks","cockshit","cocksmith","cocksmoke","cocksmoker","cocksniffer","cocksuck","cocksucked","cocksucker","cocksucking","cocksucks","cocksuka","cocksukka","cockwaffle","cok","cokmuncher","coksucka","coochie","coochy","coon","coons","cooter","coprolagnia","coprophilia","cornhole","cox","cracker","crap","creampie","crotte","cum","cumbubble","cumdumpster","cumguzzler","cumjockey","cummer","cumming","cums","cumshot","cumslut","cumtart","cunilingus","cunillingus","cunnie","cunnilingus","cunt","cuntass","cuntface","cunthole","cuntlick","cuntlicker","cuntlicking","cuntrag","cunts","cuntslut","cyalis","cyberfuc","cyberfuck","cyberfucked","cyberfucker","cyberfuckers","cyberfucking","d1ck","dago","damn","darkie","date rape","daterape","deep throat","deepthroat","deggo","dendrophilia","dick","dick-sneeze","dickbag","dickbeaters","dickface","dickfuck","dickfucker","dickhead","dickhole","dickjuice","dickmilk ","dickmonger","dicks","dickslap","dicksucker","dicksucking","dicktickler","dickwad","dickweasel","dickweed","dickwod","dike","dildo","dildos","dingleberries","dingleberry","dink","dinks","dipshit","dirsa","dirty pillows","dirty sanchez","dlck","dog style","dog-fucker","doggie style","doggiestyle","doggin","dogging","doggy style","doggystyle","dolcett","domination","dominatrix","dommes","donkey punch","donkeyribber","doochbag","dookie","doosh","double dong","double penetration","doublelift","douche","douche-fag","douchebag","douchewaffle","dp action","dry hump","duche","dumass","dumb ass","dumbass","dumbcunt","dumbfuck","dumbshit","dumshit","dvda","dyke","eat my ass","ecchi","ejaculate","ejaculated","ejaculates","ejaculating","ejaculatings","ejaculation","ejakulate","erotic","erotism","escort","eunuch","f u c k","f u c k e r","f_u_c_k","f4nny","fag","fagbag","fagfucker","fagging","faggit","faggitt","faggot","faggotcock","faggs","fagot","fagots","fags","fagtard","fanny","fannyflaps","fannyfucker","fanyy","fatass","fcuk","fcuker","fcuking","fecal","feck","fecker","felch","felching","fellate","fellatio","feltch","female squirting","femdom","figging","fingerbang","fingerfuck","fingerfucked","fingerfucker","fingerfuckers","fingerfucking","fingerfucks","fingering","fistfuck","fistfucked","fistfucker","fistfuckers","fistfucking","fistfuckings","fistfucks","fisting","flamer","flange","foah","fook","fooker","foot fetish","footjob","frotting","fuck","fuck buttons","fuck off","fucka","fuckass","fuckbag","fuckboy","fuckbrain","fuckbutt","fuckbutter","fucked","fucker","fuckers","fuckersucker","fuckface","fuckhead","fuckheads","fuckhole","fuckin","fucking","fuckings","fuckingshitmotherfucker","fuckme","fucknut","fucknutt","fuckoff","fucks","fuckstick","fucktard","fucktards","fucktart","fucktwat","fuckup","fuckwad","fuckwhit","fuckwit","fuckwitt","fudge packer","fudgepacker","fuk","fuker","fukker","fukkin","fuks","fukwhit","fukwit","futanari","fux","fux0r","g-spot","gang bang","gangbang","gangbanged","gangbangs","gay","gay sex","gayass","gaybob","gaydo","gayfuck","gayfuckist","gaylord","gaysex","gaytard","gaywad","genitals","giant cock","girl on","girl on top","girls gone wild","goatcx","goatse","god damn","god-dam","god-damned","goddamn","goddamned","goddamnit","gokkun","golden shower","goo girl","gooch","goodpoop","gook","goregasm","gringo","grope","group sex","guido","guro","hand job","handjob","hard core","hard on","hardcore","hardcoresex","heeb","hell","hentai","heshe","ho","hoar","hoare","hoe","hoer","homo","homodumbshit","homoerotic","honkey","hooker","hore","horniest","horny","hot carl","hot chick","hotsex","how to kill","how to murder","huge fat","humping","incest","intercourse","jack Off","jack-off","jackass","jackoff","jaggi","jagoff","jail bait","jailbait","jap","jelly donut","jerk off","jerk-off","jerkass","jigaboo","jiggaboo","jiggerboo","jism","jiz","jizm","jizz","juggs","jungle bunny","junglebunny","kawk","kike","kinbaku","kinkster","kinky","knob","knobbing","knobead","knobed","knobend","knobhead","knobjocky","knobjokey","kock","kondum","kondums","kooch","kootch","kraut","kum","kummer","kumming","kums","kunilingus","kunja","kunt","kyke","l3i+ch","l3itch","labia","lameass","lardass","leather restraint","leather straight jacket","lemon party","lesbian","lesbo","lezzie","lmfao","lolita","lovemaking","lust","lusting","m0f0","m0fo","m45terbate","ma5terb8","ma5terbate","make me come","male squirting","masochist","master-bate","masterb8","masterbat","masterbat3","masterbate","masterbation","masterbations","masturbate","mcfagget","menage a trois","mick","milf","minge","missionary position","mo-fo","mof0","mofo","mothafuck","mothafucka","mothafuckas","mothafuckaz","mothafucked","mothafucker","mothafuckers","mothafuckin","mothafucking","mothafuckings","mothafucks","mother fucker","motherfuck","motherfucked","motherfucker","motherfuckers","motherfuckin","motherfucking","motherfuckings","motherfuckka","motherfucks","mound of venus","mr hands","muff","muff diver","muffdiver","muffdiving","munging","mutha","muthafecker","muthafuckker","muther","mutherfucker","n1gga","n1gger","nambla","nawashi","nazi","negro","neonazi","nig nog","nigaboo","nigg3r","nigg4h","nigga","niggah","niggas","niggaz","nigger","niggers","niglet","nimphomania","nipple","nipples","nob","nob jokey","nobhead","nobjocky","nobjokey","nsfw images","nude","nudity","numbnuts","nut sack","nutsack","nympho","nymphomania","octopussy","omorashi","one cup two girls","one guy one jar","orgasim","orgasims","orgasm","orgasms","orgy","p0rn","paedophile","paki","panooch","panties","panty","pawn","pecker","peckerhead","pedobear","pedophile","pegging","penis","penisbanger","penisfucker","penispuffer","phone sex","phonesex","phuck","phuk","phuked","phuking","phukked","phukking","phuks","phuq","piece of shit","pigfucker","pimpis","piss","piss pig","pissed","pissed off","pisser","pissers","pisses","pissflaps","pissin","pissing","pissoff","pisspig","playboy","pleasure chest","pole smoker","polesmoker","pollock","ponyplay","poof","poon","poonani","poonany","poontang","poop","poop chute","poopchute","poopuncher","porch monkey","porchmonkey","porn","porno","pornography","pornos","prick","pricks","prince albert piercing","pron","pthc","pube","pubes","punanny","punany","punta","pusse","pussi","pussies","pussy","pussylicking","pussys","pust","puto","queaf","queef","queer","queerbait","queerhole","quim","raghead","raging boner","rape","raping","rapist","rectum","renob","retard","reverse cowgirl","rimjaw","rimjob","rimming","rosy palm","rosy palm and her 5 sisters","ruski","rusty trombone","s.o.b.","s&m","sadism","sadist","sand nigger","sandler","sandnigger","sanger","santorum","scat","schlong","scissoring","screwing","scroat","scrote","scrotum","seks","semen","sex","sexo","sexy","shag","shagger","shaggin","shagging","shaved beaver","shaved pussy","shemale","shi+","shibari","shit","shitass","shitbag","shitbagger","shitblimp","shitbrains","shitbreath","shitcanned","shitcunt","shitdick","shite","shited","shitey","shitface","shitfaced","shitfuck","shitfull","shithead","shithole","shithouse","shiting","shitings","shits","shitspitter","shitstain","shitted","shitter","shitters","shittiest","shitting","shittings","shitty","shiz","shiznit","shota","shrimping","skank","skeet","skullfuck","slag","slanteye","slut","slutbag","sluts","smeg","smegma","smut","snatch","snowballing","sodomize","sodomy","son-of-a-bitch","spac","spic","spick","splooge","splooge moose","spooge","spook","spread legs","spunk","strap on","strapon","strappado","strip club","style doggy","suck","suckass","sucks","suicide girls","sultry women","swastika","swinger","t1tt1e5","t1tties","tainted love","tard","taste my","tea bagging","teets","teez","testical","testicle","threesome","throating","thundercunt","tied up","tight white","tit","titfuck","tits","titt","tittie5","tittiefucker","titties","titty","tittyfuck","tittywank","titwank","tongue in a","topless","tosser","towelhead","tranny","tribadism","tub girl","tubgirl","turd","tushy","tw4t","twat","twathead","twatlips","twats","twatty","twatwaffle","twink","twinkie","two girls one cup","twunt","twunter","unclefucker","undressing","upskirt","urethra play","urophilia","v14gra","v1gra","va-j-j","vag","vagina","vajayjay","venus mound","viagra","vibrator","violet wand","vjayjay","vorarephilia","voyeur","vulva","w00se","wang","wank","wanker","wankjob","wanky","wet dream","wetback","white power","whoar","whore","whorebag","whoreface","willies","willy","wop","wrapping men","wrinkled starfish","xrated","xx","xxx","yaoi","yellow showers","yiffy","zoophilia","zubb","a$$","a$$hole","a55hole","ahole","anal impaler","anal leakage","analprobe","ass fuck","ass hole","assbang","assbanged","assbangs","assfaces","assh0le","beatch","bimbo","bitch tit","bitched","bloody hell","bootee","bootie","bull shit","bullshits","bullshitted","bullturds","bum boy","butt fuck","buttfuck","buttmunch","c-0-c-k","c-o-c-k","c-u-n-t","c.0.c.k","c.o.c.k.","c.u.n.t","caca","cacafuego","chi-chi man","child-fucker","clit licker","cock sucker","corksucker","corp whore","crackwhore","dammit","damned","damnit","darn","dick head","dick hole","dick shy","dick-ish","dickdipper","dickflipper","dickheads","dickish","f-u-c-k","f.u.c.k","fist fuck","fuck hole","fuck puppet","fuck trophy","fuck yo mama","fuck you","fuck-ass","fuck-bitch","fuck-tard","fuckedup","fuckmeat","fucknugget","fucktoy","fuq","gassy ass","h0m0","h0mo","ham flap","he-she","hircismus","holy shit","hom0","hoor","jackasses","jackhole","middle finger","moo foo","naked","p.u.s.s.y.","piss off","piss-off","rubbish","s-o-b","s0b","shit ass","shit fucker","shiteater","son of a bitch","son of a whore","two fingers","wh0re","wh0reface"]
        setInterval(() => {
            if (this.state.appstate === 'started') {
                this.count ++;
                if(this.count === 60){
                
                    this.setState({ appstate: 'download' })
                    window.mediaRecorder.stop();
                    this.stopStream();
                    alert('Seems like you forgot to stop recording, Recording stoped automatically')
                }
                
            }
        }, 1000);
    }

    componentDidMount = () => {
        if(UserSession.getSession().userDetail){
           this.userDetail = UserSession.getSession().userDetail;
           this.email_id = UserSession.getSession().email_id;
        }else{
            window.location.href = '/';
        }
        window.downloadLink = document.getElementById('download');
        //this.onNewChat('Hi how are you ',false,true)

    }
    componentWillUnmount = () => {
        
    }
    getScreenCapture = () => {
        if (navigator.getDisplayMedia) {
            return navigator.getDisplayMedia({
                video: true,
                audio: true
            });
        } else if (navigator.mediaDevices.getDisplayMedia) {
            return navigator.mediaDevices.getDisplayMedia({
                video: true,
                audio: true
            });
        } else {
            return navigator.mediaDevices.getUserMedia({
                video: {
                    mediaSource: 'screen'
                },
                audio: true
            });
        }
    }
    startGoogleTrans = () => {
        try {
            window.AudioContext = window.AudioContext || window.webkitAudioContext;
            window.audioContext = new AudioContext();
        } catch (e) {
            alert('Web Audio API not supported.');
        }
        //let audio = { echoCancellation: true, noiseSuppression: true , sampleRate:41000}
        this.getScreenCapture().then(this.handleSuccessGoogle, (error) => {
                alert('UNABLE TO CAPTURE AUDIO, PLEASE GIVE ACCESS')
                this.onRefresh();
        });
    }
    handleError = (error) => {

    }
    stopStream = () => {
        window.systemStream.getTracks().forEach(function (track) {
            track.stop();
        });
        window.micStream.getTracks().forEach(function (track) {
            track.stop();
        });
        window.finalStream.getTracks().forEach(function (track) {
            track.stop();
        });
    }
    disableVideo = (stream) => {
        stream.getVideoTracks().forEach((track) => {
            track.enabled = false;
        });
    }
    handleSuccessGoogle = (stream) => {
        navigator.getUserMedia({ video: false, audio: true }, (myStream) => {
            window.micStream = myStream;
            this.startGoogleAfterSuccess(stream)
        },(error)=>{
            alert('UNABLE TO CAPTURE Mic, PLEASE GIVE PERMISSION')
            this.onRefresh();
        });
        this.setState({ appstate: 'started' })
        


    }
    startGoogleAfterSuccess = (systemStream) =>{
        window.systemStream = systemStream;
        this.disableVideo(systemStream);
        this.startRecord(systemStream)
        let stream = window.finalStream;
        //document.getElementById('videoscrn').srcObject = stream;
        //document.getElementById('videoscrn').play();
        stream.oninactive = () => {
            console.log('STREAM END DUE TO INACTIVITY');
            this.stopStream()
        };
        
        var script = window.audioContext.createScriptProcessor(4096, 1, 1);
        script.onaudioprocess = (event) => {
            // console.log('audio activity')
            var input = event.inputBuffer.getChannelData(0) || new Float32Array(4096);
            for (var idx = input.length, newData = new Int16Array(idx); idx--;)
                newData[idx] = 32767 * Math.min(1, input[idx]);
            if (window.socketGoogle != null) {
                // console.log('start');
                if (window.socketGoogle.readyState === 1) {
                    // console.log('ready state 1');
                    // console.log('Sending data to server..')
                    window.socketGoogle.send(newData);
                }
            }
        }
        window.socketGoogle.onmessage = (b) => {
            const data = JSON.parse(b.data);
            if (data.isFinal) {
                this.onNewChat(data.text,false,true)
                
                let param = {
                    question: data.text,
                    input: "voice"
                }
                RequestHandler.postPlain('https://gdbt.canstrings.com/godigitbot', param, (response) => {
                // RequestHandler.postPlain('https://34.211.153.140:8082/godigitbot', param, (response) => {
                    // RequestHandler.postPlain('https://mlcb.canstrings.com/chatbot', param, (response) => {
                    this.setState({botAnsewer: true});
                    this.setState({botInputAnsewer: response.input});
                    this.onNewChat(response.response,true,true)
                })
            } else {
                this.setState({toquestion: true});
                this.onNewChat(data.text,false,false)
                this.count = 0;
            }
        };

        var mic = window.audioContext.createMediaStreamSource(stream);
        mic.connect(script);
        script.connect(window.audioContext.destination);

        window.socketGoogle = window.socketGoogle;
        window.script = script;
    }
    processSpeach = (speach) =>{
        /*
        let wordArray = speach.split(' ');
        for(let i =0; i< wordArray.length; i++){
            let wd = wordArray[i];
            wd = wd.toLowerCase();
        */
        speach = speach.toLowerCase();
        let bdwordlist = '';
            for(let j=0;j<this.badWords.length;j++){
                let bdwd = this.badWords[j];
                bdwd = bdwd.toLowerCase();
                if(speach.search(bdwd) !== -1){
                    if(bdwordlist){
                        bdwordlist = bdwordlist+','+bdwd.toLocaleUpperCase();
                    }else{
                        bdwordlist = bdwd.toLocaleUpperCase()
                    }
                }
            }
        //}
        if(bdwordlist.length > 2){
            this.showModal('Banned words (<b>'+bdwordlist+' </b>) detected in your conversation on '+new Date().toLocaleDateString()+' '+new Date().toLocaleTimeString()+'. Sysem will report it to concerned team, watch the recorded session later for more information.</b>');
        }
        
    }
    onNewChat = (message,bot,isfinal) =>{

       let chatElem = '';
       if(isfinal){
            if(bot){
                const typeOf = typeof message;
                if(typeOf === 'string') {
                    if(this.state.botInputAnsewer === 'text') {
                        chatElem += '<div>';                                      
                        chatElem += '<div class="message from">';
                        chatElem += '<div>';
                        chatElem +=  '<img src="/files/chat_bot_logo.png" id="chatImg" />';
                        chatElem += '<span id="canStringTitleFrom">CanString</span>';
                        chatElem += '</div>';
                        chatElem += '<div id="bot">'+message+'</div>';
                        chatElem += '</div>';
                        chatElem += '</div>';
                    }
                } else {
                    var newArr = [];
                    for(var i = 0; i < message.length; i++)
                    {
                        newArr = newArr.concat(message[i]);
                    }
                    for(let msg of newArr) {
                    chatElem += '<div>';                                      
                    chatElem += '<div class="message from">';
                    chatElem += '<div>';
                    chatElem +=  '<img src="/files/chat_bot_logo.png" id="chatImg" />';
                    chatElem += '<span id="canStringTitleFrom">CanString</span>';
                    chatElem += '</div>';
                    chatElem += '<div id="bot">'+msg+'</div>';
                    chatElem += '</div>';
                    chatElem += '</div>';
                    }
                }
            }else{
                chatElem += '<div >';
                chatElem += '<span id="yourSentMessage">Sender</span>';
                chatElem += '<div class="message to">';
                chatElem += '<div id="captionbot">'+message+'</div>';
                chatElem += '</div>';
                chatElem += '</div>';
                
            }
            this.finalHtml += chatElem;
            document.getElementById('chat-area').innerHTML = this.finalHtml;
            
        }else{
            chatElem += '<div>';
            chatElem += '<span id="yourSentMessage">Sender</span>';
            chatElem += '<div class="message to">';
            chatElem += '<div id="captionbot">'+message+'</div>';
            chatElem += '</div>';
            chatElem += '</div>';
            document.getElementById('chat-area').innerHTML = this.finalHtml + chatElem;
        }
       
       document.getElementById('chat-area').scrollTop = document.getElementById('chat-area').scrollHeight;
       this.processSpeach(message);
       
    }
    startRecord = (stream) => {
        window.options = { mimeType: 'audio/webm' };
        window.recordedChunks = [];
        const ac = new AudioContext();
        const source1 = ac.createMediaStreamSource(new MediaStream([stream.getAudioTracks()[0]]))
        const source2 = ac.createMediaStreamSource(new MediaStream([window.micStream.getAudioTracks()[0]]))
        
        const dest = ac.createMediaStreamDestination();
        source1.connect(dest)
        source2.connect(dest)
        window.finalStream = dest.stream;
        window.mediaRecorder = new MediaRecorder(dest.stream, window.options);
        window.mediaRecorder.addEventListener('dataavailable', (e) => {
            if (e.data.size > 0) {
                window.recordedChunks.push(e.data);
            }

        });

        window.mediaRecorder.addEventListener('stop', () => {
            window.downloadLink.href = URL.createObjectURL(new Blob(window.recordedChunks));
            window.downloadLink.download = 'recording.wav';
        });

        window.mediaRecorder.start();
    }
    onRefresh = () =>{
        window.location.reload();
    }
    generateUID = ()=>{
        return (Math.floor(Math.random() * 100000000000) + 100000000000).toString().substring(1);
    }
    startGoogleSocket = () => {
        if (this.state.appstate === 'stopped') {
            

        } else if (this.state.appstate === 'started') {
            this.setState({ appstate: 'download' })
            window.mediaRecorder.stop();
            this.stopStream();
            window.socketGoogle.close();
            //alert('RECORDED FILE URL : https://meet.canstringai.com:80/recorded/'+this.recordId+'.wav')
            return;
        }
        if (window.googleConnected) {
            return;
        }
        this.recordId = this.generateUID()
        // alert(this.email_id)
        window.socketGoogle = new WebSocket("wss://"+Config.DOMAIN+":80/?name=user&room="+this.email_id+'&language='+this.state.languge);
       //window.socketGoogle = new WebSocket("wss://localhost/?name=user&room=100");
        //socket = new WebSocket("wss://localhost/");
        window.socketGoogle.binaryType = "arraybuffer";
        window.socketGoogle.onopen = () => {
            console.log('WSS SOCKET SUCCESSFULLY CONNECTED');
            window.socketGoogle.send('start');
            this.startGoogleTrans();
            window.googleConnected = true;
        }
        window.socketGoogle.onclose = (e) => {
            switch (e.code) {
                case 1000: // CLOSE_NORMAL
                    console.log("WebSocket: closed");
                    break;
                default: // Abnormal closure
                    this.onReconnectGoogle(window.socketGoogle);
                    break;
            }
        }
        window.socketGoogle.onerror = (e) => {
            switch (e.code) {
                case 'ECONNREFUSED':
                    this.onReconnectGoogle(window.socketGoogle);
                    break;
                default:

                    break;
            }
        }
    }
    onReconnectGoogle = (socketGoogle) => {
        window.socketGoogle = null;
        setTimeout(() => {
            console.log("WebSocketClient: reconnecting...");
            this.startGoogleSocket()
        }, 5000);
    }
    onMessageKeyUp = (e)=>{
        var code = (e.keyCode ? e.keyCode : e.which);
        if (code == 13) {
           let text = document.getElementById('msg-inp').value;
           if(text){
            this.onNewChat(text,false,true)
                let param = {
                    question: text,
                    input: "text"
                }
                document.getElementById('msg-inp').value = '';
                RequestHandler.postPlain('https://gdbt.canstrings.com/godigitbot', param, (response) => {
                    // RequestHandler.postPlain('https://34.211.153.140:8082/godigitbot', param, (response) => {
                    this.setState({botAnsewer: true});
                    this.setState({botInputAnsewer: response.input});
                    this.onNewChat(response.response,true,true)
                    
                })
           }
        }
    }
    onLogout = ()=>{
        window.localStorage.clear();
        window.location.href = '/';
    }
    onLanguageSwitch = (event) =>{
        this.setState({languge:event.target.value})
    }
    onAwsCall = () =>{
        this.showModal();
    }
    showModal = (msg) =>{
        if(msg){
            document.getElementById('custon-popup-msg').innerHTML = msg;
            document.getElementById('custon-popup-msg').style.display = 'block';
            document.getElementById('static-msg').style.display = 'none';
            document.getElementById('proceedbtn').style.display = 'none';
            
        }else{
            document.getElementById('static-msg').style.display = 'block';
            document.getElementById('custon-popup-msg').style.display = 'none';
            document.getElementById('proceedbtn').style.display = 'inline';
        }
        document.getElementById('custom-popup').style.display = 'block';
    }
    hideModal = () =>{
        document.getElementById('custom-popup').style.display = 'none';
    }
    onProceedModal = () =>{
        this.callAWSConnect();
    }
    callAWSConnect = (data) => {
        /*
        const payload = {
            user_id: this.state.meetSelectedUser.user_id,
            to_user_name: this.state.meetSelectedUser.full_name,
            phone_no: this.state.meetSelectedUser.phone_no
        }
        RequestHandler.post(Config.API_DOMAIN + '/canstring/v1/awsConnect', payload, (response) => {
            window.open('https://canstringmeet.my.connect.aws/ccp-v2/softphone', '_blank');
        });
        */
        window.open('https://canstringmeet.my.connect.aws/ccp-v2/softphone', '_blank');
    }
    render() {
        return (
            <div>
                <div className='bot-recommentation'>
                            <div class="msg-container bg-white">
                                <div class="chat-header rtc-dev">
                                    <img src="/files/chat_bot_logo.png" id="headerImg" />
                                    <span
                                        id="projName">CanString Recommendation</span>
                                        <div class="tab-content btn-div" id="myTabContent" >
                                            <select className={this.state.appstate === 'stopped' ? "lang-drop":'hide'} onChange={this.onLanguageSwitch}>
                                                <option value="en-IN">Indian English (en-IN)</option>
                                                <option value="en-US">US English (en-US)</option>
                                                <option value="hi-IN">Hindi (hi-IN)</option>
                                                <option value="es-AR">Spanish (es-AR)</option>
                                                <option value="es-AR">French (fr-FR)</option>
                                                <option value="it-IT">Italian (it-IT)</option>
                                                <option value="ml-IN">Malayalam (ml-IN)</option>
                                                <option value="ta-IN">Tamil (ta-IN)</option>
                                            </select>
                                            <a id="download" onClick={this.startGoogleSocket} data-tip={this.state.appstate === 'stopped' ? "Start Recording": this.state.appstate === 'started' ? "Stop Recording" : "Download"}>
                                                <i class="fa fa-microphone" className={this.state.appstate === 'stopped' ? "fa fa-microphone" : this.state.appstate === 'started' ? "fa fa-stop-circle-o" : "fa fa-download"}></i>
                                            </a>
                                            <a className="marg-left-15" onClick={this.onAwsCall} data-tip="Call">
                                                <i class="fa fa-phone"></i>
                                            </a>
                                            <a className="marg-left-15" onClick={this.onRefresh} data-tip="Reset">
                                                <i class="fa fa-refresh"></i>
                                            </a>
                                        </div>
                                </div>
                                <div id="chat-area" class="chat-area">
                                
                                </div>
                                <input id="msg-inp" className="rec-inp" placeholder="Enter your query here..." onKeyUp={this.onMessageKeyUp} type="text"/>
                                <div id="canstring-text">Powered By CanString </div>
                            </div>
                        </div>
                
                <ReactTooltip place="top" type="dark" effect="float" />
                <div id='custom-popup' className='custom-popup'>
                        <div className='popup-body'>
                            <div id='static-msg' className='custon-popup-msg'>
                                <h6>Once you click proceed button AWS Connect ( A tool For Webcall ) will open, Then do the following steps.</h6>
                                <h6 className='imp'>IMPORTANT : Read all the steps before clicking proceed</h6>
                                <ul>
                                <li className='shaded'>1. Login with the following credentials.<br/>username : <b>canstring</b>  paassword : <b>Canstring@123#</b></li>
                                <li >2. Once call started, return to this page then close this popup and click mic ( <i class="fa fa-microphone"></i> ) button on top right.</li>
                                <li className='shaded'>3. From the screenshare popup select Chrome tab and choose the aws connect tab, then click share button</li>
                                <img className='helpimg' src="files/awsconnectins.png" />
                                <li >4. Stay on this page, so that you can see the recomendations here</li>
                                </ul>
                                {/*<iframe src='https://canstringmeet.my.connect.aws/ccp-v2/softphone'></iframe>*/}
                                
                            </div>
                            <div id='custon-popup-msg' className='custon-popup-msg customtxt'>
                                
                                
                            </div>
                            <div id='custon-popup-button'>
                                <button id='proceedbtn' onClick={this.onProceedModal} className="btn">Proceed</button> <button className="btn redbg" onClick={this.hideModal}>Close</button>
                            </div>
                        </div>
                       
                </div>
            </div>
        )
    }
}
export default Record;
